import { graphql } from 'client/gql';
import { ThreemaProps } from 'client/gql/graphql';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import { useState } from 'react';
import { useQuery } from 'urql';
import { showUserDbErrorToast } from 'utils/toasts';
import { BpSubpage } from '../../../components/BpSubpage/BpSubpage';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { ThreemaAssignModal } from './threema/ThreemaAssignModal';
import { ThreemaTable } from './threema/ThreemaTable';

const ThreemaSubpageQueryDocument = graphql(`
  query ThreemaSubpageData($organizationUuid: ID!, $profile: ID!) {
    ...ThreemaTable
    ...PermissionCheckerFields
    ...ThreemaAssignModal
  }
`);

export const ThreemaSubpage = () => {
  const { pimAuthClaims } = useAuthClaims();
  const organization = pimAuthClaims.getOrganization();
  const profileUuid = pimAuthClaims.getProfile().uuid;
  const organizationUuid = pimAuthClaims.getOrganizationUuid();
  const [openedThreemaProps, setOpenedThreemaProps] = useState<ThreemaProps | null>(null);

  const [{ data, error }] = useQuery({
    query: ThreemaSubpageQueryDocument,
    variables: {
      organizationUuid,
      profile: profileUuid,
    },
  });

  if (error) showUserDbErrorToast();

  const permissions = usePermissionChecker(data);

  return (
    <BpSubpage isForbidden={!permissions?.isOrganizationAdmin(organization)}>
      <ThreemaTable query={data} handleAssignClick={(threemaProps) => setOpenedThreemaProps(threemaProps)} />
      <ThreemaAssignModal
        query={data}
        isOpen={Boolean(openedThreemaProps)}
        threemaDetails={openedThreemaProps}
        onRequestClose={() => setOpenedThreemaProps(null)}
      />
    </BpSubpage>
  );
};
